// extracted by mini-css-extract-plugin
export default {"tableContainer":"shipmentOfPickups_tableContainer__hnIaT","contentTable":"shipmentOfPickups_contentTable__EQw+h","button":"shipmentOfPickups_button__4v35d"};